/* eslint-disable no-console */
import { io } from 'socket.io-client'
import store from '../store/store'

class SocketManager {
  constructor() {

    if (localStorage.user) {
      let user = JSON.parse(localStorage.user)
      if (user)
        this.connect(user)
    }
  }

  connect (user) {
    if (!this.connected) {

      this.socket = io.connect(new URL(store.state.baseUrl).origin, {
        path: new URL(store.state.baseUrl).pathname + '/socket.io',
        transports: ['websocket'],
        auth: {
          type: 'user',
          name: user.username,
          token: user.websocketAuthToken
        }
      });

      this.socket.on('InvalidToken', async (token) => {
        this.connected = false;
        console.log("InvalidToken socket auth token");
        try {
          let response = await store.dispatch('getUserById', user._id)
          try {
            let userEndpoint = await store.dispatch(
              "getEndpointByDeviceType",
              user._id
            );
            if (userEndpoint && userEndpoint._id) {
              response.endpoint = userEndpoint;
            }
          } catch (e) {
            console.log(e);
          }
          console.log('response', response)
          localStorage.user = JSON.stringify(response)
          console.log("Retrying socket connect with updated token");
          this.connect(response);
        } catch (e) {
          console.error(e);
        }
      })

      this.socket.on('connect', () => {
        this.connected = true;
        console.log('SocketManager - connect from server');
        if (window.initSocket) {
          window.initSocket();
        }
      });

      this.socket.on('disconnect', (resp) => {
        this.connected = false
        console.log('SocketManager - disconnected from server', resp);
      });

      this.socket.on('connect_error', (resp) => {
        this.connected = false
        console.log('SocketManager - connect_err from server', resp);
      });

      this.socket.io.on('error', (resp) => {
        console.log('SocketManager - error from server', resp);
      });

      this.socket.io.on('reconnect', (attempt) => {
        this.connected = true;
        console.log('SocketManager - reconnect', attempt);
      });

      this.socket.io.on('reconnect_attempt', (attempt) => {
        console.log('SocketManager - reconnect_attempt', attempt);
      });

      this.socket.io.on('reconnect_error', (err) => {
        console.log('SocketManager - reconnect_error', err);
      });

      this.socket.io.on('reconnect_failed', () => {
        console.log('SocketManager - reconnect_failed');
      });
    }
  }

  disconnect () {
    this.socket.disconnect();
    this.connected = false;
  }

  emit (type, data) {
    if (this.connected) {
      this.socket.emit(type, data);
    } else {
      console.log('Not emitting as socket disconnected');
    }
  }

  on (type, handler) {
    if (this.connected) {
      this.socket.off(type)
      this.socket.on(type, param => handler(param));
    } else {
      console.log('Not listening as socket disconnected');
    }

    return this;
  }

  off (type) {
    if (this.connected) {
      this.socket.off(type)
    } else {
      console.log('Not off as socket disconnected');
    }
    return this
  }
}

export default new SocketManager()
